import React, { Component } from 'react'
import { Form, Input, Button, Card, Divider, Alert, Image } from 'antd'
import { formLayout, tailLayout } from '..'
import { FormConsumer } from '../../../context/FormContext'
import './style.less'

type AuthFormProps = {
  loading: boolean,
  error: string | null,
  onLogin: Function,
  resetErrorsDispatch: Function,

  // Browser history
  history: any,
}

export default class AuthForm extends Component<AuthFormProps> {
  static defaultProps = {
    loading: false,
    error: null,
    onLogin: () => {},
    resetErrorsDispatch: () => {},
  }

  componentWillUnmount() {
    this.props.resetErrorsDispatch()
  }

  handleLoginSubmit = (values: any) => {
    this.props.onLogin(values)
  }

  renderLoginForm = () => {
    const { loading, error } = this.props

    return (
      <FormConsumer>
        {({ form, onFormChange }: any) => {
          const values = form.login || {}

          return (
            <>
              {
                error ? (
                  <>
                    <Alert type="error" message={error} />
                    <Divider />
                  </>
                ) : null
              }

              <Form
                {...formLayout}
                name="login"
                hideRequiredMark={true}
                initialValues={values}
                onFinish={this.handleLoginSubmit}
                onChange={onFormChange}
              >
                <Form.Item
                  label="Email"
                  name={['admin_user', 'email']}
                  rules={[
                    {
                      type: 'email',
                      message: 'This is not a valid Email'
                    },
                    {
                      required: true,
                      message: 'Please input your email'
                    }
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name={['admin_user', 'password']}
                  rules={[{
                    required: true,
                    message: 'Please input your password'
                  }]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Login
                  </Button>
                </Form.Item>
              </Form>
            </>
          )
        }}
      </FormConsumer>
    )
  }

  render() {
    return (
      <div className="auth-container">
        <div className="content">
          <div className="logo">
            <Image
              width={200}
              src={require('../../../assets/images/adopets-primary-logo-v2.png')}
            />
          </div>

          <Divider />

          <Card title="Authentication">
            {
              this.renderLoginForm()
            }
          </Card>
        </div>
      </div>
    )
  }
}
